module.exports = __webpack_public_path__ + "img/p6.f5e77481.png";